
export function useI18n(namespace) {

  return {
    t: () =>"自行修改",
  };
}

